document.addEventListener('click', function (e) {
  // Find the link that was clicked, even if they clicked an icon/span inside it
  const link = e.target.closest('a[href]');
  if (!link) return;

  let url;
  try {
    url = new URL(link.href, window.location.origin);
  } catch (err) {
    return; // not a real URL (e.g. "javascript:void(0)"), skip it
  }

  // External = different domain than the current site
  const isExternal = url.hostname !== window.location.hostname;

  // Don't override a link that already sets its own target
  if (isExternal && !link.hasAttribute('target')) {
    e.preventDefault();
    window.open(link.href, '_blank', 'noopener');
  }
});
